export default __webpack_public_path__ + "static/media/Location.c0739d84.png";